/* eslint-disable react/no-unescaped-entities */
import {
  ContainerBg,
} from './styled';

export default function NotFound() {
  return (
    <ContainerBg>
      Página não encontrada!
    </ContainerBg>
  );
}
